module.exports = __webpack_public_path__ + "media/promo/lum2021/images/top-0de43eb4e65d9e7a6b9eaee8f80fd607.png";